import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { cn } from 'Components/primitives/utils';
import { buildStaticId } from 'Components/utils/buildStaticId';
import { itemVariants, ItemMedia, ItemContent, ItemTitle, ItemDescription, ItemActions, ItemHeader, ItemFooter, } from 'Components/primitives/item';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnItem',
    props: {
        title: { type: String, required: false },
        description: { type: String, required: false },
        variant: { type: String, required: false, default: 'default' },
        size: { type: String, required: false, default: 'default' },
        state: { type: String, required: false, default: 'default' },
        mediaVariant: { type: String, required: false, default: 'icon' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        staticId: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const rowVariantClass = computed(() => props.variant === 'accent' ? 'justify-center gap-3' : 'gap-3');
        const buildId = () => buildStaticId('en-item', props.staticId);
        const __returned__ = { props, rowVariantClass, buildId, get cn() { return cn; }, get itemVariants() { return itemVariants; }, get ItemMedia() { return ItemMedia; }, get ItemContent() { return ItemContent; }, get ItemTitle() { return ItemTitle; }, get ItemDescription() { return ItemDescription; }, get ItemActions() { return ItemActions; }, get ItemHeader() { return ItemHeader; }, get ItemFooter() { return ItemFooter; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
